
import { defineComponent, type PropType } from 'vue';
import { ITrailModel } from '@/types/routewebmodel';
import axios from 'axios';
import store from '@/store';
import { RegisterForFreeTrailCommand, RegisterForFreeTrailCommandResponse } from '@/types/routebeheerapimodel';
// eslint-disable-next-line
import showloader from '@/javascript/showloader.js';

export default defineComponent({
  name: 'TrailUnAuthorizedOptions',
  data() {
    return {
      email: '',
      verificationcode: '',
      usermessage: '',
      showEmailInput: true,
      showValidationInput: false,
      doValidate: false,
      emailaddressconsent: false,
    };
  },
  created() {
    store.dispatch('getMember').then(() => {
      if (store.state.member) {
        // Todo LoginInfo is wel iets uitgebreid.
        this.email = (store.state.member.LoginInfo.Email)
          ? store.state.member.LoginInfo.Email
          : store.state.member.LoginInfo.UserName;
      }
    });
  },
  props: {
    trail: {
      type: Object as PropType<ITrailModel>,
      required: true,
    },
  },
  computed: {
    invalidEmail() {
      return this.validateEmail(this.email, 'e-mailadres', true);
    },
  },
  methods: {
    validate() {
      this.doValidate = true;
      return !(this.invalidEmail);
    },
    validateEmail(value: string, label: string, required: boolean) {
      if (!this.doValidate) {
        return null;
      }
      if (!value) {
        return required ? `${label}: verplicht` : null;
      }

      if (value !== '') {
        const rx = /^[\w-.]+@([\w-]+\.)+[\w-]{2,63}$/;
        if (!rx.test(value)) {
          return `${label}: Dit is geen geldig e-mailadres`;
        }
        return null;
      }
      return null;
    },
    async onSubmit(e: Event) {
      e.preventDefault();
      if (!this.validate()) {
        return;
      }
      showloader.showLoader(true);
      const data = new RegisterForFreeTrailCommand();
      data.email = this.email;
      data.trailId = this.trail.trailId;
      data.origin = this.$route.fullPath;
      const res = await fetch('/umbraco/api/Gateway/RegisterFreeTrailUser', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      const resData = await res.json();
      this.usermessage = resData.message;
      this.showEmailInput = false;
      showloader.showLoader(false);

      if (resData.needsVerification) {
        this.showValidationInput = true;
      } else {
        this.usermessage = 'Ok';
        setTimeout(() => { window.location.href = `/bevestig-gratis-route/?hash=${encodeURIComponent(resData.hash)}&origin=${this.$route.fullPath}`; }, 10);
      }
    },
    async onSubmitVerification(e: Event) {
      e.preventDefault();

      showloader.showLoader(true);
      const data = {
        VerificationCode: this.verificationcode,
        Email: this.email,
      };
      axios.post('/umbraco/api/Gateway/ConfirmEmailAddress', data)
        .then((result) => {
          showloader.showLoader(false);
          this.usermessage = result.data.message;
          if (result.data.validated) {
            // eslint-disable-next-line
            setTimeout(() => { window.location.href = `/bevestig-gratis-route/?hash=${encodeURIComponent(result.data.hash)}&origin=${this.$route.fullPath}`; }, 10);
          }
        });
    },
    async processRegisterFreeTrailUserResponse(data: RegisterForFreeTrailCommandResponse) {
      if (data.success) {
        // success = true;
        // state.usermessage = `het is gelukt ${data.message}`;
      } else {
        // state.success = false;
        // state.usermessage = `Helaas ${data.message}`;
      }
    },
  },
});
